import { Typography } from '@mui/material'
import { layout } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Breadcrumbs } from '@/components/ui/Breadcrumbs'
import { CategoryGrid } from '@/components/sections/CategoryGrid'
import { ContactCTA } from '@/components/sections/ContactCTA'
import { Seo } from '@/components/seo/Seo'

export function ProductsOverview() {
  return (
    <>
      <Seo title="Products" path="/products" description="Explore True Forge welding gloves, driver gloves, welding caps and leather garments." />

      <Section sx={{ pb: 0 }}>
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Products' }]} />
        <Eyebrow>Our Products</Eyebrow>
        <Typography variant="h1" component="h1" sx={{ maxWidth: 940 }}>
          Protection engineered for every task
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 3, maxWidth: layout.contentMaxWidth }}>
          Explore our full range of welding gloves, driver gloves, welding caps and leather garments &amp; accessories.
        </Typography>
      </Section>

      <Section>
        <CategoryGrid />
      </Section>

      <ContactCTA />
    </>
  )
}
